export const styles = {
    header: {
        fontWeight: "bold",
        border: "2px solid rgb(251, 204, 8)",
        borderRadius: "5px",
        textAlign: "center",
        height: "110px",
        lineHeight: "25px",
        fontSize: "13px",
    },
    logo: {
        position: 'absolute',
        width: '90px',
        top: '34px',
        left: '34px'
    },
    title: {
        position: "relative",
        top: "10px",
        fontSize: "17px",
        padding: '0 100px'
    },
    flag: {
        position: 'absolute',
        width: '90px',
        top: '57px',
        right: '34px'
    },
    subtitle: {
        fontWeight: 'bold',
        width: '100%',
        textAlign: 'center',
        marginTop: '10px',
        fontSize: '13px',
    },
    containerTable: {
        backgroundColor: 'rgb(229, 229, 229)}'
    },
    table: {
        width: '101%',
        textAlign: 'left',
        marginLeft: '-3px',
        borderSpacing: '0px'
    },
    tableHead: {
        fontSize: '13px'
    },
    tableRow: {
        borderBottom: '1px solid rgb(224, 224, 224)',
        fontSize: '13px',
        padding: '7px 0px'
    },
    lastRowTable: {
        backgroundColor: 'rgb(211, 211, 211)',
        fontWeight: 'bold',
        fontSize: '13px'
    }
}